import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  "navTheme": "light",
  "colorPrimary": "#13C2C2",
  "layout": "top",
  "contentWidth": "Fixed",
  "fixedHeader": true,
  "fixSiderbar": true,
  "splitMenus": false,
  title: ' ',
  pwa: true,
  logo: 'https://sequilern.com/static/media/logo.53dc6c949dd243c4283c89d72105eeb4.svg',
  iconfontUrl: '',
  token: {
    // See ts declaration, demo in docs, modify style via token
    // https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
};

export default Settings;
